<template>
<div class='project-browser-outer-container'>
  <div class="d-flex">
    <label class="project-intro-title">Current Project:</label>
    <div>
      <b-navbar-nav class="project-browser p-2">
        <project-stats :project="$store.getters['project/currentProject']" :noname="true"></project-stats>
      </b-navbar-nav>
      <b-collapse id="projectBrowserList" v-model='showProjectList'>
        <div class="flex-container">
          <b-card>
            <b-container class="pl-1 pr-1 mt-1">
              <b-form-group id="filterProjectGroup" label-for="filterLayers">
                <b-form-input v-model="projectQ" class="input-xs" id="filterProjects" type="text" placeholder="Type to filter projects">
                  <b-button size="sm">
                    <icon name="search" scale=".6" label="Filter layers"></icon>
                  </b-button>
                </b-form-input>
              </b-form-group>
            </b-container>
          </b-card>
          <div class="flex-full-height">
            <project-list class="project-browser"></project-list>
          </div>
        </div>

      </b-collapse>
    </div>
  </div>

</div>
</template>
<script>
import ProjectList from './ProjectList'
import ProjectStats from './ProjectStats'
export default {
  name: 'project-browser',
  components: {
    ProjectStats,
    ProjectList
  },
  computed: {
    projectQ: {
      get() {
        return this.$store.getters['project/projectQ']
      },
      set(val) {
        this.$store.commit('project/projectQ', val)
      }
    },
    showProjectList: {
      get() {
        return this.$store.getters['project/showProjectList']
      },
      set(val) {
        this.$store.commit('project/showProjectList', val)
      },
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/projects/ProjectBrowser.vue